(function () {
  'use strict';
  var decision = null;
  var hiddenReason = '';
  var refreshPending = false;
  var shown = false;
  var purchaseIntent = false;
  var intentSource = '';
  var storageKey = 'ps_shipping_interest_hidden_v1';
  var previewStorageKey = 'ps_shipping_interest_preview_country_v1';
  var preview = '';

  try {
    hiddenReason = window.sessionStorage.getItem(storageKey) || '';
  } catch (_storageRead) {}
  if (hiddenReason !== 'dismissed' && hiddenReason !== 'us_address' && hiddenReason !== 'notify_success') hiddenReason = '';
  if (window.location.host === 'compat-dev.paintscratch.com') {
    var parts = (window.location.search || '').replace(/^\?/, '').split('&');
    var previewCount = 0;
    var previewCountry = '';
    var i;
    for (i = 0; i < parts.length; i++) {
      var equal = parts[i].indexOf('=');
      var key;
      try { key = decodeURIComponent((equal < 0 ? parts[i] : parts[i].slice(0, equal)).replace(/\+/g, ' ')); } catch (_previewKey) { continue; }
      if (key !== 'ps_shipping_country') continue;
      previewCount++;
      try { previewCountry = equal < 0 ? '' : decodeURIComponent(parts[i].slice(equal + 1).replace(/\+/g, ' ')); } catch (_previewValue) { previewCountry = ''; }
    }
    if (previewCount) {
      if (previewCount === 1 && validPreviewCountry(previewCountry)) {
        try { window.sessionStorage.setItem(previewStorageKey, previewCountry); } catch (_previewWrite) {}
      } else {
        previewCountry = '';
        try { window.sessionStorage.removeItem(previewStorageKey); } catch (_previewClear) {}
      }
    } else {
      try { previewCountry = window.sessionStorage.getItem(previewStorageKey) || ''; } catch (_previewRead) {}
    }
    if (validPreviewCountry(previewCountry)) preview = '?ps_shipping_country=' + previewCountry;
  }

  function validPreviewCountry(value) { return value === 'US' || value === 'ES' || value === 'unknown'; }

  function request(path, method, payload, callback) {
    var done = false;
    function finish(value) {
      if (done) return;
      done = true;
      if (callback) callback(value);
    }
    try {
      var xhr = new XMLHttpRequest();
      xhr.open(method, '/api/shipping-interest/' + path + preview, true);
      xhr.timeout = 4000;
      if (payload) xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function () {
        var value = null;
        if (xhr.status >= 200 && xhr.status < 300) {
          try { value = JSON.parse(xhr.responseText); } catch (_json) {}
        }
        finish(value);
      };
      xhr.onerror = xhr.ontimeout = xhr.onabort = function () { finish(null); };
      xhr.send(payload ? JSON.stringify(payload) : null);
    } catch (_request) { finish(null); }
  }

  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try { return !!privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true; } catch (_privacy) { return false; }
  }

  function event(name, source) {
    if (!analyticsAllowed()) return;
    request('event', 'POST', {
      event: name,
      source: source,
      page_url: window.location.protocol + '//' + window.location.host + window.location.pathname,
      analytics_consent: true
    });
  }

  function remember(reason) {
    hiddenReason = reason;
    try { window.sessionStorage.setItem(storageKey, reason); } catch (_storageWrite) {}
    refresh();
  }

  function field(root, name) { return root.querySelector('[data-ps-shipping-' + name + ']'); }

  function active(root) {
    var surface = root.getAttribute('data-ps-shipping-surface');
    if (surface !== 'add_to_cart' && !(parseInt(root.getAttribute('data-ps-shipping-count'), 10) > 0)) return false;
    if (surface === 'cart_page') return true;
    var node = root.parentNode;
    while (node && node !== document.body) {
      if (surface === 'add_to_cart' && node.id === 'cart-notification') {
        var product = node.querySelector('#cart-notification-product');
        return node.classList.contains('active') && !!product && /\S/.test(product.textContent || '');
      }
      if (node.tagName === 'CART-DRAWER') return node.classList.contains('active') && !node.classList.contains('is-empty');
      node = node.parentNode;
    }
    return false;
  }

  function sourceFor(root) {
    if (root.getAttribute('data-ps-shipping-surface') === 'add_to_cart') return 'add_to_cart';
    return root.getAttribute('data-ps-shipping-surface') === 'cart_page' ? 'cart_page' : (intentSource || 'cart_drawer');
  }

  function cartContext(root, payload) {
    // The notification injects added products after this initial cart snapshot.
    if (root.getAttribute('data-ps-shipping-surface') === 'add_to_cart') return;
    var total = root.getAttribute('data-ps-shipping-cart-total');
    if (typeof total === 'string' && /^\d+(?:\.\d{1,2})?$/.test(total) && Number(total) <= 10000000) payload.cart_total = Number(total);
    try {
      var items = JSON.parse(root.getAttribute('data-ps-shipping-cart-summary') || 'null');
      if (!Array.isArray(items) || !items.length) return;
      var summary = [];
      var i;
      for (i = 0; i < items.length && i < 10; i++) {
        var item = items[i];
        if (!item || typeof item.product_id !== 'number' || typeof item.quantity !== 'number' || !isFinite(item.product_id) || !isFinite(item.quantity) || item.product_id <= 0 || item.product_id > 9007199254740991 || Math.floor(item.product_id) !== item.product_id || item.quantity <= 0 || item.quantity > 9999 || Math.floor(item.quantity) !== item.quantity) return;
        summary.push({ product_id: item.product_id, quantity: item.quantity });
      }
      payload.cart_summary = summary;
    } catch (_context) {}
  }

  function notify(root) {
    var email = field(root, 'email');
    var consent = field(root, 'consent');
    var submit = field(root, 'submit');
    var status = field(root, 'status');
    if (!email || !consent || !submit || !status || root.psShippingBusy) return;
    var value = email.value.replace(/^\s+|\s+$/g, '');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || value.length > 254) {
      status.textContent = 'Enter a valid email address.';
      return;
    }
    if (!consent.checked) {
      status.textContent = 'Check the box to ask for a shipping email.';
      return;
    }
    root.psShippingBusy = true;
    submit.disabled = true;
    status.textContent = 'Saving your request...';
    var source = sourceFor(root);
    var payload = {
      email: value,
      consent: true,
      source: source,
      page_url: window.location.protocol + '//' + window.location.host + window.location.pathname,
      referrer: (document.referrer || '').split(/[?#]/)[0]
    };
    cartContext(root, payload);
    request('notify', 'POST', payload, function (response) {
      root.psShippingBusy = false;
      submit.disabled = false;
      if (!response || response.ok !== true) {
        status.textContent = 'We could not save your request. Please try again.';
        return;
      }
      email.value = '';
      consent.checked = false;
      root.psShippingSuccess = true;
      field(root, 'body').hidden = true;
      status.textContent = 'Thanks. We will email you if shipping opens in your country.';
      event('notify_submitted', source);
      remember('notify_success');
    });
  }

  function ownInput(target) {
    return target && (target.getAttribute('data-ps-shipping-email') !== null || target.getAttribute('data-ps-shipping-consent') !== null);
  }

  function bind(root) {
    if (root.psShippingBound) return;
    root.psShippingBound = true;
    root.addEventListener('click', function (e) {
      var target = e.target;
      while (target && target !== root) {
        if (target.getAttribute('data-ps-shipping-dismiss') !== null) {
          event('dismissed', sourceFor(root));
          remember('dismissed');
          return;
        }
        if (target.getAttribute('data-ps-shipping-us-address') !== null) {
          event('us_address', sourceFor(root));
          remember('us_address');
          return;
        }
        if (target.getAttribute('data-ps-shipping-notify') !== null) {
          field(root, 'signup').hidden = false;
          target.setAttribute('aria-expanded', 'true');
          event('notify_opened', sourceFor(root));
          return;
        }
        if (target.getAttribute('data-ps-shipping-submit') !== null) { notify(root); return; }
        target = target.parentNode;
      }
    });
    // CartItems treats all bubbling change events as quantity edits.
    root.addEventListener('change', function (e) { if (ownInput(e.target)) e.stopPropagation(); });
    // Enter in our optional fields must not submit the enclosing cart form.
    root.addEventListener('keydown', function (e) {
      if (ownInput(e.target) && (e.key === 'Enter' || e.keyCode === 13)) { e.preventDefault(); notify(root); }
    });
  }

  function refresh() {
    var roots = document.querySelectorAll('[data-ps-shipping-interest]');
    var i;
    for (i = 0; i < roots.length; i++) {
      var root = roots[i];
      bind(root);
      var visible = !!decision && active(root) && (!hiddenReason || (hiddenReason === 'notify_success' && root.psShippingSuccess === true));
      if (root.hidden !== !visible) root.hidden = !visible;
      if (visible && !hiddenReason) {
        if (!purchaseIntent) { purchaseIntent = true; event('purchase_intent', sourceFor(root)); }
        if (!shown) { shown = true; event('shown', sourceFor(root)); }
      }
    }
  }

  function scheduleRefresh() {
    if (refreshPending) return;
    refreshPending = true;
    window.setTimeout(function () { refreshPending = false; refresh(); }, 0);
  }

  function start() {
    refresh();
    if (window.MutationObserver && document.body) {
      var observer = new window.MutationObserver(scheduleRefresh);
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
        if (data && data.source === 'product-form' && data.cartData && !data.cartData.status && (data.cartData.id || data.cartData.items)) {
          intentSource = 'add_to_cart';
          scheduleRefresh();
        }
      });
    }
    request('state', 'GET', null, function (state) {
      if (state && state.version === 1 && state.warn === true && typeof state.country === 'string' && /^[A-Z]{2}$/.test(state.country) && state.country !== 'US') decision = state;
      refresh();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
